import { Trans, useTranslation } from "react-i18next";

import { LegalBrand, LegalPageLayout, List, Section } from "./LegalPageLayout";

const CONTACT = "hello@delgentic.com";

/**
 * Plain-English cookie/storage notice. The app sets no advertising or
 * analytics cookies; it uses browser localStorage for the sign-in session and
 * a little essential UI state (theme, language, seen activity). Keep in sync
 * with the frontend storage usage.
 *
 * <p>Copy lives in the i18n bundles under {@code cookies.*}.</p>
 */
export function CookiePolicyPage({
  brand,
  onSignup,
}: {
  brand: LegalBrand;
  onSignup: () => void;
}) {
  const { t } = useTranslation();

  const rich = {
    strong: <strong />,
    mail: <a className="underline" href={`mailto:${CONTACT}`} />,
  };

  return (
    <LegalPageLayout
      title={t("cookies.title")}
      updated={t("cookies.updated")}
      brand={brand}
      onSignup={onSignup}
    >
      <Section heading={t("cookies.short.heading")}>
        <p>{t("cookies.short.body")}</p>
      </Section>

      <Section heading={t("cookies.store.heading")}>
        <p>{t("cookies.store.intro")}</p>
        <List>
          {[0, 1].map((i) => (
            <li key={i}>
              <Trans i18nKey={`cookies.store.items.${i}`} components={rich} />
            </li>
          ))}
        </List>
      </Section>

      <Section heading={t("cookies.idp.heading")}>
        <p>{t("cookies.idp.body")}</p>
      </Section>

      <Section heading={t("cookies.noTracking.heading")}>
        <p>{t("cookies.noTracking.body")}</p>
      </Section>

      <Section heading={t("cookies.manage.heading")}>
        <p>{t("cookies.manage.body")}</p>
      </Section>

      <Section heading={t("cookies.contact.heading")}>
        <p>
          <Trans i18nKey="cookies.contact.body" components={rich} />
        </p>
      </Section>
    </LegalPageLayout>
  );
}
